<template lang="pug">
b-container.pb-4
  b-row.align-items-center
    b-col.mb-5.mb-md-0(md="4")
      .d-flex.align-items-center.flex-column
        b-img.mb-3.mb-lg-5(
          src="@/assets/logo-tall.png",
          alt="logo_2_scape_masajes_domicilio"
        )
        .d-flex.align-items-center.flex-column.flex-lg-row
          b-link.mr-0.mr-lg-3.mb-3.mb-lg-0(
            href="https://apps.apple.com/mx/app/scape/id1317228026",
            target="_blank"
          )
            b-img(
              src="@/assets/app-store.png",
              height="30",
              alt="app_store_masajes_domicilio"
            )
          b-link(
            href="https://play.google.com/store/apps/details?id=mx.scape.scape&hl=es_MX",
            target="_blank"
          )
            b-img(
              src="@/assets/google-play.png",
              height="30",
              alt="play_store_masajes_domicilio"
            )
    b-col.text-center.text-md-left.mb-5.mb-md-0(md="2")
      p.bold Scape
      p
        b-link.text-reset(:to="{ name: 'home' }") Inicio
      p
        b-link.text-reset(:to="{ name: 'services' }") Servicios
      p
        b-link.text-reset(:to="{ name: 'gifts' }") Certificados de regalo
      p
        b-link.text-reset(:to="{ name: 'work' }") Trabaja en Scape
      p.mb-0
        b-link.text-reset(:to="{ name: 'coverage' }") Cobertura
    b-col.text-center.text-md-left.mb-5.mb-md-0(md="3")
      p
        b-link.text-reset(:to="{ name: 'hotels' }") Scape hoteles
      p
        b-link.text-reset(:to="{ name: 'companies' }") Scape empresas
      //- p
      //-   b-link.text-reset Medidas de seguridad
    b-col.text-center.text-md-left.mb-5.mb-md-0(md="3")
      p.bold Recursos
      p
        b-link.text-reset(:to="{ name: 'faqs' }") FAQ's
      p
        b-link.text-reset(
          href="https://scape.mx/media/scape-press-kit.pdf",
          target="_blank"
        ) Press kit
      p
        b-link.text-reset(:to="{ name: 'terms' }") Términos y condiciones
      p
        b-link.text-reset(:to="{ name: 'privacy' }") Aviso de privacidad para clientes
      p
        b-link.text-reset(:to="{ name: 'privacy_therapist' }") Aviso de privacidad para terapeutas
      p
        b-link.text-reset(:to="{ name: 'cookies' }") Política del uso de cookies
      p
        b-link.text-reset(:to="{ name: 'copyright' }") Aviso Derecho de Autor
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
</style>
